export enum AppRole {
  ADMIN = 'admin',
  CLIENT = 'client'
}

export enum SessionStatus {
  OPEN = 'open',
  SUBMITTED = 'submitted',
  CONFIRMED = 'confirmed',
  EDITING = 'editing',
  EDITED = 'edited',
  COMPLETED = 'completed'
}

export interface ChatMessage {
  id: string;
  sender: 'admin' | 'client';
  text: string;
  timestamp: number;
  read?: boolean;
}

export interface DriveHistoryEntry {
  type: 'original' | 'edited';
  url: string;
  timestamp: number;
  folderId: string;
}

export interface DriveFile {
  fileId: string;
  name: string;
  thumbnailLink: string;
  previewLink?: string;
  fullSizeLink?: string;
  mimeType: string;
  size?: number;
  createdTime?: number;
  downloadUrl?: string;
}

export interface PhotoSession {
  id: string;
  access_code: string;
  client_id: string;
  drive_folder_id: string;
  edited_folder_id?: string;
  max_selection: number;
  selected_files: string[]; 
  comments?: { [filename: string]: string };
  messages?: ChatMessage[];
  drive_history?: DriveHistoryEntry[];
  expiry_date: number;
  status: SessionStatus;
  created_at: number;
  drive_files: DriveFile[];
  edited_files?: DriveFile[];
  is_confirmed?: boolean;
}

export interface ClientData {
  id: string;
  order_id: string;
  client_name: string;
  email: string;
  phone: string;
  event_date: string;
  service_type: string;
}

export interface StudioSettings {
  google_api_key: string;
}

export interface ElectronBridge {
  selectFolder: () => Promise<string | null>;
  moveFiles: (sourceDir: string, filenames: string[]) => Promise<{ success: boolean; count: number; path?: string; error?: string }>;
  readLocalFolder: (path: string) => Promise<string[]>;
  getPlatform: () => string;
  onSortProgress: (callback: (data: { percent: number, currentFile: string, movedCount: number }) => void) => void;
  removeSortListeners: () => void;
}

declare global {
  interface Window {
    electron?: ElectronBridge;
  }
}
